import { BitfPaginationApiRequestPart } from '@bitf/core/api-call-state/bitf-pagination-api-request-part';

import { EApiCallStateNames, EApiRequestPartKeys, EBitfApiSortDirection } from '@enums';
import { IBitfApiCallState } from '@interfaces';
import { DefaultApiCallStateMapper } from './default-api-call-state.mapper';
// tslint:disable-next-line:max-line-length
import { BitfPSortApiRequestPart } from '@common/libs/bitforce/core/api-call-state/bitf-p-api-call-state/bitf-p-sort-api-request-part.builder';
// tslint:disable-next-line:max-line-length
import { BitfPFormItemConfigApiRequestPart } from '@common/libs/bitforce/core/api-call-state/bitf-p-api-call-state/bitf-p-form-item-config-api-request-part.builder';
// tslint:disable-next-line:max-line-length
import { FsSearchApiRequestPart } from '@web/shared/components/file-system/fs-search/fs-search-api-request-part.builder';

export const apiCallStateConfig = [
  // {
  //   apiCallStateName: EApiCallStateNames.DEMO,
  //   apiRequest: {
  //     // NOTE passing page and size from here is still valid if BitfPaginationApiRequestPart is not used
  //     // page: 1,
  //     // size: 2,
  //     sorting: [{ property: 'firstName', direction: 'ASC' }],
  //   },
  //   requestParts: [
  //     new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { page: 1, size: 2 }),
  //     new SearchApiRequestPart(),
  //   ],
  //   apiCallStateMapper: new DefaultApiCallStateMapper(),
  // } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.CALENDAR_EVENTS_LIST,
    apiRequest: {
      page: 0,
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { paginationInfo: '', size: 50 }),
      new BitfPFormItemConfigApiRequestPart(),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_TITLE,
        defaultPartData: {
          data: { property: 'title', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_TYPE,
        defaultPartData: {
          data: { property: 'eventCategory', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_START_DATE,
        defaultPartData: {
          data: { property: 'startTime', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_END_DATE,
        defaultPartData: {
          data: { property: 'endTime', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_CREATED_BY,
        defaultPartData: {
          data: { property: 'createdBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_MODIFIED_BY,
        defaultPartData: {
          data: { property: 'modifiedBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_CREATED,
        defaultPartData: {
          data: { property: 'created', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_EVENT_LIST_MODIFIED,
        defaultPartData: {
          data: { property: 'modified', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.NEWS_LIST,
    apiRequest: {
      page: 0,
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { paginationInfo: '', size: 50 }),
      new BitfPFormItemConfigApiRequestPart(),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_TITLE,
        defaultPartData: {
          data: { property: 'title', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_PUBLISHED_FROM,
        defaultPartData: {
          data: { property: 'publishedFrom', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_PUBLISHED_TO,
        defaultPartData: {
          data: { property: 'publishedTo', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_CREATED_BY,
        defaultPartData: {
          data: { property: 'createdBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_MODIFIED_BY,
        defaultPartData: {
          data: { property: 'modifiedBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_CREATED,
        defaultPartData: {
          data: { property: 'created', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_NEWS_MODIFIED,
        defaultPartData: {
          data: { property: 'modified', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.TAGS_LIST,
    apiRequest: {
      page: 0,
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { paginationInfo: '', size: 50 }),
      new BitfPFormItemConfigApiRequestPart(),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_TITLE,
        defaultPartData: {
          data: { property: 'title', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_DESCRIPTION,
        defaultPartData: {
          data: { property: 'description', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_CREATED_BY,
        defaultPartData: {
          data: { property: 'createdBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_MODIFIED_BY,
        defaultPartData: {
          data: { property: 'modifiedBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_CREATED,
        defaultPartData: {
          data: { property: 'created', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_TAGS_MODIFIED,
        defaultPartData: {
          data: { property: 'modified', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.DOCUMENT_ARCHIVE_LIST,
    apiRequest: {
      page: 0,
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { paginationInfo: '', size: 50 }),
      new BitfPFormItemConfigApiRequestPart(),
      new FsSearchApiRequestPart(),
      // new BitfPSortApiRequestPart({
      //   key: EApiRequestPartKeys.SORT_FS_ITEM_CONTENT_TYPE,
      //   defaultPartData: {
      //     data: { property: 'contentType', direction: EBitfApiSortDirection.DESC },
      //   },
      // }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_NAME,
        defaultPartData: {
          data: { property: 'name', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_CREATED_BY,
        defaultPartData: {
          data: { property: 'createdBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED_BY,
        defaultPartData: {
          data: { property: 'modifiedBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_CREATED,
        defaultPartData: {
          data: { property: 'created', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED,
        defaultPartData: {
          data: { property: 'modified', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.SURVEY_ARCHIVE_LIST,
    apiRequest: {
      page: 0,
    },
    requestParts: [
      new BitfPaginationApiRequestPart(EApiRequestPartKeys.PAGINATION, { paginationInfo: '', size: 50 }),
      new BitfPFormItemConfigApiRequestPart(),
      new FsSearchApiRequestPart(),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_NAME,
        defaultPartData: {
          data: { property: 'name', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_CREATED_BY,
        defaultPartData: {
          data: { property: 'createdBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED_BY,
        defaultPartData: {
          data: { property: 'modifiedBy', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_CREATED,
        defaultPartData: {
          data: { property: 'created', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
      new BitfPSortApiRequestPart({
        key: EApiRequestPartKeys.SORT_FS_ITEM_MODIFIED,
        defaultPartData: {
          data: { property: 'modified', direction: EBitfApiSortDirection.UNDEFINED },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
